<template>
  <superslide :options="options" class="slideBox">
    <!-- slides -->
    <div class="bd">
      <ul>
        <li>
          <a href="javascript:;">11</a>
          <a href="javascript:;">12</a>
          <a href="javascript:;">13</a>
          <a href="javascript:;">14</a>
          <a href="javascript:;">15</a>
          <a href="javascript:;">16</a>
        </li>
        <li>
          <a href="javascript:;">21</a>
          <a href="javascript:;">22</a>
          <a href="javascript:;">23</a>
          <a href="javascript:;">24</a>
          <a href="javascript:;">25</a>
          <a href="javascript:;">26</a>
        </li>
        <li>
          <a href="javascript:;">31</a>
          <a href="javascript:;">32</a>
          <a href="javascript:;">33</a>
          <a href="javascript:;">34</a>
          <a href="javascript:;">35</a>
          <a href="javascript:;">36</a>
        </li>
      </ul>
    </div>

    <!-- Optional controls slots -->
    <!-- slot="titCell" -->
    <div class="hd" slot="titCell">
      <ul>
        <li class="on">1</li>
        <li class="">2</li>
        <li class="">3</li>
      </ul>
    </div>

    <!-- slot="prev" -->
    <a class="prev" href="javascript:void(0)" slot="prev"></a>
    <!-- slot="next" -->
    <a class="next" href="javascript:void(0)" slot="next"></a>

    <!-- slot="pageStateCell" -->
    <span class="pageState" slot="pageStateCell"></span>
  </superslide>
</template>

<script>
  export default {
    name: "slideBox",
    data () {
      return {
        options: {
          mainCell: ".bd ul",
          // vis: 4,
          effect: "leftLoop",
        trigger: "click",
        easing: "easeOutElastic"
          // autoPlay: true
        }
      }
    }
  }
</script>

<style type="text/css">
  /* 本例子css */
  .slideBox {
    width: 450px;
    height: 230px;
    overflow: hidden;
    position: relative;
    border: 1px solid #ddd;
  }
  .slideBox .hd {
    height: 15px;
    overflow: hidden;
    position: absolute;
    right: 5px;
    bottom: 5px;
    z-index: 1;
  }
  .slideBox .hd ul {
    overflow: hidden;
    zoom: 1;
    float: left;
  }
  .slideBox .hd ul li {
    float: left;
    margin-right: 2px;
    width: 15px;
    height: 15px;
    line-height: 14px;
    text-align: center;
    background: #fff;
    cursor: pointer;
  }
  .slideBox .hd ul li.on {
    background: #f00;
    color: #fff;
  }
  .slideBox .bd {
    position: relative;
    height: 100%;
    z-index: 0;
  }
  .slideBox .bd li {
    zoom: 1;
    width: 60px;
    height: 30px;
    vertical-align: middle;
  }
  .slideBox .bd img {
    width: 450px;
    height: 230px;
    display: block;
  }

  /* 下面是前/后按钮代码，如果不需要删除即可 */
  .slideBox .prev,
  .slideBox .next {
    position: absolute;
    left: 3%;
    top: 50%;
    margin-top: -25px;
    display: block;
    width: 32px;
    height: 40px;
    background: red -110px 5px no-repeat;
    filter: alpha(opacity=50);
    opacity: 0.5;
  }
  .slideBox .next {
    left: auto;
    right: 3%;
    background-position: 8px 5px;
  }
  .slideBox .prev:hover,
  .slideBox .next:hover {
    filter: alpha(opacity=100);
    opacity: 1;
  }
  .slideBox .prevStop {
    display: none;
  }
  .slideBox .nextStop {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/sakura/portrait/test.vue